<template>
  <v-autocomplete
    v-model="model"
    variant="outlined"

    color="secondary"
    :label="required ? '*' + $t('User.Timezone') : $t('User.Timezone')"
    :items="items"
    item-title="timezone_name"
    item-value="id"

    :name="fieldKey"
    :hint="hint"
    :error-messages="errorMessages"
    :disabled="disabled"

    @keyup.enter="$emit('enter')"
  />
</template>

<script>
  import axios from 'axios'
  import settings from '@/settings'
  import { mapGetters } from 'vuex'
  import InputMixin from './InputMixin'
  import * as utils from '@/library/utils'

  export default {
    mixins: [InputMixin],
    emits: ['enter', 'update:model-value'],
    data: () => ({
      model: String,
      items: [],
      appendIcon: null
    }),
    computed: {
      ...mapGetters([
        'login'
      ])
    },
    watch: {
      model () {
        this.$emit('update:model-value', this.model)
      }
    },
    created () {
      axios.get(settings.ApiUrl + 'timezones/', { params: { limit: 1000 } }).then((res) => {
        res.data.results.forEach((result) => {
          this.items.push({
            timezone_name: `(UTC${result.utc_offset}) ${result.id}`,
            id: result.id
          })
        })
        this.model = this.modelValue ? this.modelValue : utils.expectationTimeZone()
      })
    }
  }
</script>
